<template lang="pug">
modal#remove-team-modal(
  :buttonColor='buttonColor'
  :close-button-label='$t("button.cancel")'
  :loading='loading'
  :process-button-label='$t("button.remove")'
  :title='$t("modal.removeTeam.title")'
  @process='removeTeam'
  ref='modal'
)
  .modal-body
    .text {{ $t('modal.removeTeam.message') }}
</template>

<script>
import Modal from '@/ui/molecules/Modal.vue';
import ImageLoader from '@/ui/molecules/ImageLoader.vue';
import TeamsService from '@/modules/business/services/http/organizations/teams/TeamsService';
import formHandler from '@/modules/account/common/formHandler';
import alert from '@/modules/account/common/alert';

export default {
  name: 'RemoveTeamModal',
  components: {
    Modal,
    TeamsService,
    ImageLoader,
  },
  props: {
    teamId: [Number, String],
  },
  data() {
    return {
      loading: false,
      buttonColor: true,
    };
  },
  methods: {
    async removeTeam() {
      formHandler.submit(this, () => TeamsService.remove(this.teamId), {
        successHandler: (response) => {
          if (response.status === 204) {
            alert.fireAlert(this.$t('modal.removeTeam.successMessage'), {
              classes: 'alert-success',
              styles:
                'background-color: #d4edda; border-color: #c3e6cb; color: #155724;',
              icon: 'circle-check',
            });
            this.loading = false;
            this.$refs.modal.close();
            this.$router.push('/business/teams');
          }
        },
      });
    },
  },
};
</script>
